import FeedDataType from "./FeedDataType";
export default [
    {
        "provider": "CAT",
        "feedDataType": FeedDataType.TdsV2Cat,
        "url": "https://services.cat.com/telematics/iso15143/fleet/1",
        "refreshInSeconds": 3600
    },
    {
        "provider": "CAT",
        "feedDataType": FeedDataType.TdsV1,
        "url": "https://www.myvisionlink.com/APIService/AEMP/v1/Fleet",
        "refreshInSeconds": 3600
    },
    {
        "provider": "Liebherr",
        "feedDataType": FeedDataType.TdsV1,
        "url": "https://www.lidatexternal.liebherr.com/LidatExternal/Service.svc/aemp/fleet",
        "refreshInSeconds": 3600
    },
    {
        "provider": "Volvo",
        "feedDataType": FeedDataType.TdsV1,
        "url": "https://api.caretrackvolvo.com/aemp/resources/fleet",
        "refreshInSeconds": 3600,
    },
    {
        "provider": "Volvo",
        "feedDataType": FeedDataType.TdsV2VolvoCareTrack,
        "url": "https://api-awe.volvo.com/vce/cs/aemp/v1/Fleet/1",
        "refreshInSeconds": 3600,
        "oauth2url": "https://login.microsoftonline.com/f25493ae-1c98-41d7-8a33-0be75f5fe603/oauth2/v2.0/token"
    },
    {
        "provider": "Wirtgen",
        "feedDataType": FeedDataType.TdsV1,
        "url": "https://fmi.witos.wirtgen-group.com/webservices/fmi_rest",
        "refreshInSeconds": 3600
    },
    {
        "provider": "Hitachi",
        "feedDataType": FeedDataType.TdsV1,
        "url": "https://application12.globaleservice.com/TelematicsAPI/api/AEMP12/daily/v1",
        "refreshInSeconds": 3600
    },
    {
        "provider": "FEED GENERATOR",
        "feedDataType": FeedDataType.TdsV1,
        "url": "https://feed-generator.azurewebsites.net/tds12?customer={organisationId}",
        "refreshInSeconds": 3600
    }
];
